import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { AppJsonInfoPanel } from '@/features/controller/configuration/components/AppJsonInfoPanel'
import { ControllerConfigurationFileProvider } from '@/features/controller/configuration/contexts/ControllerConfigurationFileContext'
import { ControllerConfigurationBasePage } from '@/features/controller/configuration/pages/ControllerConfigurationBasePage'
import { ControllerConfigTypeId } from '@/features/controller/configuration/types'
import { AppJsonConfigType } from '@/features/controller/configuration/utils/controllerConfigTypes'
import { ControllerRouteInformation } from '@/features/controller/constants'

export function ControllerConfigurationAppJsonPage() {
  const { controllerId } = useParams()
  const { t } = useTranslation()

  if (!controllerId) {
    return null
  }

  return (
    <ControllerConfigurationFileProvider configTypeId={ControllerConfigTypeId.AppJson} controllerId={controllerId}>
      <ControllerConfigurationBasePage
        activeTab={ControllerRouteInformation.CONTROLLER_CONFIG_APP_JSON.routePath}
        configType={AppJsonConfigType}
        controllerId={controllerId}
        infoPanel={<AppJsonInfoPanel />}
        pageTitle={t('controllers.configuration.app_json.title')}
      />
    </ControllerConfigurationFileProvider>
  )
}
